/**
 * ActorInfoApi - User input definition
 * @interface ActorInfoApi
 */
export interface ActorInfoApi {
  actor_uuid?: string;
  actorName: string;
  name?: string;
  email: string;
  role_uuids: string[];
  company_uuids: string[];
  all_companies?: boolean;
  is_active?: boolean;
  has_task?: boolean;
}

/** Same actor UUID (e.g. websocket lock holder vs signed-in user). */
export function isActorUuidMatch(
  a: string | undefined | null,
  b: string | undefined | null
): boolean {
  if (a == null || b == null) return false;
  const left = String(a).trim().toLowerCase();
  const right = String(b).trim().toLowerCase();
  return left.length > 0 && left === right;
}

export interface ActorSummaryListInputApi {
  filter?: string;
  pageSize: number;
  pageNumber: number;
}

export interface Tasks {
  external_id: string;
  is_deleted: boolean;
  domain: string;
  model: string;
  key: string;
  display: string;
  order: number;
}

export interface ActorSummary {
  actor_uuid: string;
  first_name: string;
  last_name: string;
  email: string;
  modified_by: string;
  last_action_at?: string;
  last_action: string;
  tasks: ActorSummaryTasks;
}

export interface ActorSummaryTasks {
  workflow?: Workflow;
  blueprint?: Blueprint;
}

export interface Blueprint {
  Blueprints: string[];
}

export interface Workflow {
  WorkflowStepConfigs: string[];
}

export interface UpdateActorTaskInput {
  domain: string;
  model: string;
  key: string;
  actor_uuid: string;
  value: boolean;
}

export const USER_PERMISSIONS = [
  "report:page",
  "report:add",
  "report:cancel",
  "report:due_date",
  "report:note",
  "report:unlock",
  "report:profile_confirm",
  "report:post_scrape",
  "report:post_rate",
  "report:completed",
  "report:open_dispute",
  "report:dispute",
  "company:page",
  "company:add",
  "user:page",
  "user:add",
  "user:edit",
  "user:role",
  "user:permission",
  "blueprint:page",
  "blueprint:new",
  "workflow:page",
  "workflow:analyst_assign",
  "workflow:thresholds",
  "sub_company_settings:view",
];

export type ApplicationPermissions = (typeof USER_PERMISSIONS)[number];
